export var FORM_BUTTON_TEXTS = {
    previous: "Anterior",
    next: "Próximo",
    preview: "Visualizar",
    edit: "Editar",
    complete: "Enviar",
    submitting: "Enviando...",
};
